import { useLocalisation } from "@3plearning/lingui-cdn";
import PropTypes from "prop-types";
import React from 'react';
import { Button } from "@3plearning/react-components";
import { useSelector } from "react-redux";
import { selectIsAssigningOrUnAssigning } from "../../selectors";

import UnassignWarningModalInner from "./styled";

import getTranslations from '../../translations';

const UnassignWarningModal = ({ callback }) => {
  const { i18n } = useLocalisation();
  const {
    UNASSIGN_MODAL_HEADER_TEXT,
    UNASSIGN_MODAL_CONTENT_TEXT,
    UNASSIGN_MODAL_SUBMIT_TEXT
  } = getTranslations({ i18n });

  const isAssigningOrUnAssigning = useSelector(selectIsAssigningOrUnAssigning);

  return (
    <UnassignWarningModalInner>
      <h1>{UNASSIGN_MODAL_HEADER_TEXT}</h1>
      <p>{UNASSIGN_MODAL_CONTENT_TEXT}</p>
      <Button
        onClick={() => callback()}
        className="button"
        primary
        text={UNASSIGN_MODAL_SUBMIT_TEXT}
        type={Button.LOZENGE}
        disabled={isAssigningOrUnAssigning}
      />
    </UnassignWarningModalInner>
  )
}

UnassignWarningModal.propTypes = {
  callback: PropTypes.func
}

export default UnassignWarningModal;